<template>
  <div class="statistics">
    <h1>Statistics</h1>
    <h1>Coming soon!</h1>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Statistics',
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
@require '../assets/styles/base.styl'

.statistics
  height 100vh
  display flex
  flex-direction column
  align-items center
  justify-content center
  color $positive
</style>
